var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value && _vm.value.length)?_c('div',{ref:"pie",staticClass:"statistics__pie"}):_c('div',{key:_vm.emptyKey,staticClass:"dashboard-empty__container"},[_c('i',{staticClass:"iconfont icon-nodata"}),_c('div',[_vm._v("暂无数据")])])}
var staticRenderFns = []

export { render, staticRenderFns }